import React from "react";
import styles from "./ReservationCircles.module.scss"
import {IClassEventReservation} from "../../../../../models/ClassEventReservation";

interface IReservationCirclesProps {
    reservation: IClassEventReservation[]
}

const ReservationCircles: React.FC<IReservationCirclesProps> = ({reservation}) => {

    let showBlueCircle = false;
    let showPinkCircle = false;

    if (reservation.length === 0) {
        showBlueCircle = false;
        showPinkCircle = false;
    }

    reservation.forEach(el => {
        if (el.type === "class-event" && el.waitingList?.length) {
            showPinkCircle = true;
            return;
        }
        if (el.type === "class-event") {
            showBlueCircle = true
            return;
        }
        if (el.type === "reservation") {
            showPinkCircle = true;
            return;
        }
    })

    return (
        <div className={styles.wrapper}>
            {
                showPinkCircle && <div className={`${styles.circle} ${styles.pink}`}></div>
            }
            {
                showBlueCircle && <div className={`${styles.circle} ${styles.blue}`}></div>
            }
        </div>
    )
}

export default ReservationCircles;